import React, { useState } from 'react';
import { Source } from '@/api/chat';
import { Clock, ChevronDown, ChevronUp, ExternalLink } from 'lucide-react';
import { formatDuration } from '@/api/chat';

interface SourceCardProps {
  source: Source;
}

export default function SourceCard({ source }: SourceCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const getSourceTypeLabel = () => {
    switch (source.type) {
      case 'video_segment':
        return '视频片段';
      case 'knowledge_entry':
        return '知识条目';
      case 'qa_pair':
        return '问答对';
      default:
        return '来源';
    }
  };

  const getSourceTypeColor = () => {
    switch (source.type) {
      case 'video_segment':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'knowledge_entry':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'qa_pair':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="border rounded-lg p-3 bg-gray-50 hover:bg-gray-100 transition-colors">
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className={`text-xs px-2 py-1 rounded-full border ${getSourceTypeColor()}`}>
            {getSourceTypeLabel()}
          </span>
          {source.timestamp && (
            <div className="flex items-center gap-1 text-xs text-gray-600">
              <Clock className="w-3 h-3" />
              <span>{formatDuration(source.timestamp)}</span>
            </div>
          )}
        </div>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-gray-400 hover:text-gray-600"
        >
          {isExpanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
      </div>

      <h4 className="font-medium text-sm text-gray-800 mb-1">{source.title}</h4>
      
      <p className={`text-sm text-gray-600 ${isExpanded ? '' : 'line-clamp-2'}`}>
        {source.content}
      </p>

      {source.confidence && (
        <div className="mt-2">
          <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
            <span>相关度</span>
            <span>{(source.confidence * 100).toFixed(0)}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-1.5">
            <div
              className="bg-blue-500 h-1.5 rounded-full"
              style={{ width: `${source.confidence * 100}%` }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
